<template>
	<span v-bind="$attrs">
		<BaseTooltip :title="title" class="inline-block w-full">
			<BaseHeading
				ref="heading"
				type="h6"
				:class="{
					'line-clamp-1': clamp == 1,
					'line-clamp-2': clamp == 2,
					'line-clamp-3': clamp == 3,
					'line-clamp-4': clamp == 4,
					'line-clamp-5': clamp == 5,
					fontClass,
				}"
				data-check-clamp
			>
				{{ title }}
			</BaseHeading>
		</BaseTooltip>
	</span>
</template>

<script lang="ts">
import BaseHeading from "~/ui-kit/components/BaseHeading.vue";
import BaseTooltip from "~/ui-kit/components/BaseTooltip.vue";

import { ref, onMounted, defineComponent } from "vue";

export default defineComponent({
	name: "DjClampedTitle",
	inheritAttrs: false,
	components: {
		BaseHeading,
		BaseTooltip,
	},
	props: {
		title: {
			type: String,
			default: "Clamped title",
		},
		fontClass: {
			type: String,
			default: "",
		},
		clamp: {
			type: Number,
			default: 2,
		},
	},
	setup() {
		const heading = ref<HTMLElement | null>(null);
		const runSecondCheckClamp = ref(true);

		function checkClamp() {
			const clampedNodeList = heading?.value?.$el;

			if (typeof clampedNodeList !== "undefined") {
				if (clampedNodeList.scrollHeight > clampedNodeList.clientHeight + 2) {
					clampedNodeList.setAttribute("data-check-clamp", "true");
				} else {
					clampedNodeList.parentElement.classList.remove("vue-custom-tooltip");
				}
			} else if (runSecondCheckClamp.value == true) {
				// Fallback: slow browsers
				runSecondCheckClamp.value = false;
				setTimeout(() => {
					checkClamp();
				}, 1000);
			}
		}

		onMounted(() => {
			setTimeout(() => {
				checkClamp();
			}, 1);
		});

		return {
			heading,
		};
	},
});
</script>
